module.exports = __webpack_public_path__ + "static/media/icon.192cca99.png";